import { useTLang } from 'intl/intl';

export function useCardProductLang() {
  return {
    text: {
      secondary: {
        showCustoms: useTLang({ id: 'menuPage.products.showCustoms.label' }),
      },
    },
  };
}
